import React from "react";
import { Zap, BadgeCheck, Lock } from "lucide-react";

const items = [
  { icon: Zap, label: "Instant confirmation" },
  { icon: BadgeCheck, label: "Verified homestay" },
  { icon: Lock, label: "Secure UPI & cards · Razorpay" },
];

export const TrustBadges = ({ className = "" }) => (
  <div className={`flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 ${className}`} data-testid="trust-badges">
    {items.map(({ icon: Icon, label }) => (
      <span key={label} className="inline-flex items-center gap-1.5 text-[11px] font-medium text-ink-soft">
        <Icon className="w-3.5 h-3.5 text-brand" aria-hidden="true" /> {label}
      </span>
    ))}
  </div>
);

export default TrustBadges;
